 <template>
  <div>
    <!-- Sponsorship/Support row -->
    <v-row align="center" justify="center" justify-md="start" class="mx-3">
      <!-- Sponsorship -->
      <v-col cols="12" md="3">
        <v-row justify="center" justify-md="space-between">
          <v-col cols="12" md="6">
            <h3 class="pt-12 pl-1">
              {{ $t("ABOUT.sponsorship_title") }}
            </h3>
          </v-col>

          <v-img
            @click="goTo('http://www.aipo.es')"
            style="cursor: pointer"
            contain
            :src="aipo"
            max-width="60"
            alt="AIPO - Logo"
            id="conference-aipo-logo"
          ></v-img>
        </v-row>
      </v-col>

      <!-- Support -->
      <v-col cols="12" lg="10" md="10">
        <h3 class="pt-12 pl-1">
          {{ $t("ABOUT.support_title") }}
        </h3>
        <v-row justify="center" justify-md="start" align="center">
          <v-img
            @click="goTo('https://www.sbc.org.br/')"
            id="conference-sbc-logo"
            style="cursor: pointer"
            contain
            :src="sbc"
            max-height="100"
            max-width="150"
            alt="Sociedade Brasileira de Comptação - Logo"
          >
          </v-img>

          <v-img
            style="cursor: pointer"
            @click="goTo('https://hci-collab.com/')"
            id="conference-hcicollab-logo"
            class="pt-8 mr-10 my-5"
            contain
            :src="hci_collab"
            max-height="100"
            max-width="150"
            alt="HCI collab - Logo"
          >
          </v-img>

          <v-img
            @click="goTo('http://www.vgcollab.com/')"
            id="conference-vgcollab-logo"
            style="cursor: pointer"
            contain
            :src="vg_collab"
            max-height="100"
            max-width="150"
            alt="VG collab - Logo"
          >
          </v-img>

          <v-img
            id="capes-logo"
            contain
            :src="capes"
            max-height="100"
            max-width="150"
            alt="Capes - Logo"
          >
          </v-img>
        </v-row>
      </v-col>
    </v-row>

    <!-- Publication row -->
    <div class="mx-3">
      <h3 class="pt-12 pl-4">
        {{ $t("ABOUT.publication_title") }}
      </h3>

      <v-row class="pl-12">
        <v-img
          @click="goTo('http://springer.com/')"
          id="conference-springer-logo"
          style="cursor: pointer"
          contain
          :src="springer"
          height="100"
          max-width="200"
          alt="Springer - Logo"
        >
        </v-img>
      </v-row>
    </div>

    <!-- Organization row -->
    <div class="mx-3">
      <h3 class="pt-12 pl-4 pb-4">
        {{ $t("ABOUT.organization_title") }}
      </h3>
      <v-row justify="center" justify-md="center">
        <v-img
          class="mb-10"
          id="conference-mackenzie-logo"
          @click="goTo('https://www.mackenzie.br/')"
          style="cursor: pointer"
          contain
          :src="mackenzie"
          max-height="100"
          max-width="200"
          alt="University Mackenzie - Logo"
        >
        </v-img>

        <v-img
          @click="goTo('http://www.facens.br')"
          id="conference-facens-logo"
          contain
          :src="facens"
          max-height="100"
          max-width="200"
          alt="University Facens - Logo"
        >
        </v-img>
      </v-row>
    </div>

    <!-- Collaboration row -->
    <div class="mx-3">
      <h3 class="pt-12 pl-4 pb-4">
        {{ $t("ABOUT.collaboration_title") }}
      </h3>

      <v-row justify="center" justify-md="start">
        <v-img
          class="mb-10"
          id="conference-ifederal-logo"
          @click="goTo('https://www.ifsp.edu.br/')"
          style="cursor: pointer"
          contain
          :src="ifsp_hortolandia"
          max-height="100"
          max-width="170"
          alt="Instituto Federal de São Paulo (Câmpus Hortolândia)- Logo"
        >
        </v-img>

        <v-img
          class="mb-10 mx-1"
          id="conference-cruzeiro-logo"
          @click="goTo('https://www.cruzeirodosul.edu.br/')"
          style="cursor: pointer"
          contain
          :src="cruzeiro"
          max-height="100"
          max-width="200"
          alt="Universidade Cruzeiro do Sul - Logo"
        >
        </v-img>
        <v-img
          class="mb-10 mx-1"
          id="conference-parana-logo"
          @click="goTo('https://www.unip.br/')"
          style="cursor: pointer"
          contain
          :src="unip"
          max-height="100"
          max-width="200"
          alt="Universidade Paulista - Logo"
        >
        </v-img>

        <v-img
          class="mb-10 mx-1"
          @click="goTo('https://www2.ufscar.br/')"
          id="conference-ufscar-logo"
          style="cursor: pointer"
          contain
          :src="ufscar"
          max-height="100"
          max-width="200"
          alt="Universidad Federal de São Carlos - Logo"
        >
        </v-img>

        <v-img
          class="mb-10 mx-1"
          id="conference-grial-logo"
          @click="goTo('https://grial.usal.es/')"
          style="cursor: pointer"
          contain
          :src="grial"
          max-height="100"
          max-width="170"
          alt="GRIAL Research Group - Logo"
        >
        </v-img>

        <v-img
          class="mb-10"
          id="conference-salamanca-logo"
          @click="goTo('https://www.usal.es/')"
          style="cursor: pointer"
          contain
          :src="univSalamanca"
          max-height="100"
          max-width="175"
          alt="Universidad Salamanca - Logo"
        >
        </v-img>

        <!-- NEW IMAGES HERE -->
        <v-img
          class="mb-10"
          id="conference-zacatecas-logo"
          @click="goTo('https://www.uaz.edu.mx/')"
          style="cursor: pointer"
          contain
          :src="uaz"
          max-height="100"
          max-width="175"
          alt="Universidad Autónoma de Zacatecas - Logo"
        >
        </v-img>

        <v-img
          class="mb-10"
          id="conference-lleida-logo"
          @click="goTo('http://www.udl.es/ca/')"
          style="cursor: pointer"
          contain
          :src="udLleida"
          max-height="100"
          max-width="175"
          alt="Universitat de Lleida - Logo"
        >
        </v-img>

        <v-img
          class="mb-10 mx-2"
          id="conference-apurimac-logo"
          @click="goTo('https://www.unamba.edu.pe/')"
          style="cursor: pointer"
          contain
          :src="unamba"
          max-height="100"
          max-width="220"
          alt="Universidad Nacional Micaela Bastidas de Apurimac - Logo"
        >
        </v-img>

        <v-img
          class="mb-10"
          id="conference-caracas-logo"
          @click="goTo('http://www.ucv.ve/')"
          style="cursor: pointer"
          contain
          :src="UCV"
          max-height="100"
          max-width="175"
          alt="Universidad Central de Venezuela - Logo"
        >
        </v-img>

        <v-img
          class="mb-10"
          id="conference-cimat-logo"
          @click="goTo('https://www.cimat.mx/')"
          style="cursor: pointer"
          contain
          :src="CIMAT"
          max-height="100"
          max-width="175"
          alt="Centro de Investigación en Matemáticas - CIMAT - Logo"
        >
        </v-img>

        <v-img
          class="mb-10"
          id="conference-santamaria-logo"
          @click="goTo('https://www.ucsm.edu.pe/')"
          style="cursor: pointer"
          contain
          :src="ucsm"
          max-height="250"
          max-width="200"
          alt=" Universidad Católica de Santa María - Logo"
        >
        </v-img>
      </v-row>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      mackenzie: require("@/assets/partners/mackenzie.png"),
      ifsp_hortolandia: require("@/assets/partners/ifsp-hortolandia.jpeg"),
      facens: require("@/assets/partners/facens_F.png"),
      cruzeiro: require("@/assets/partners/cruzeiro.png"),
      ifsp: require("@/assets/partners/ifsp.svg.png"),
      unip: require("@/assets/partners/uni-pr.png"),
      ufscar: require("@/assets/partners/ufscar.png"),
      grial: require("@/assets/partners/grial.png"),
      univSalamanca: require("@/assets/partners/univSalamanca.png"),
      aipo: require("@/assets/partners/aipo.png"),
      sbc: require("@/assets/partners/sbc.png"),
      hci_collab: require("@/assets/partners/hci_collab.png"),
      vg_collab: require("@/assets/partners/logo-vgcollab.png"),
      springer: require("@/assets/partners/springerlink.svg"),
      uaz: require("@/assets/partners/uaz.png"),
      udLleida: require("@/assets/partners/udLleida.jpg"),
      unamba: require("@/assets/partners/unamba.png"),
      UCV: require("@/assets/partners/UCV.png"),
      CIMAT: require("@/assets/partners/CIMAT.png"),
      ucsm: require("@/assets/partners/ucsm.jpeg"),
      capes: require("@/assets/partners/capes.png"),
    };
  },
  methods: {
    goTo(link) {
      window.open(link);
    },
  },
};
</script>
<style scoped>
.subject-title {
  font-size: 120%;
  font-weight: 700;
}
</style>
